module.exports = __webpack_public_path__ + "img/1607807300.e5f066dd.png";